package com.yendo.mx.ui.components

import androidx.compose.animation.core.*
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.filled.FavoriteBorder
import androidx.compose.material3.Icon
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.yendo.mx.repository.FavoritosRepository
import kotlinx.coroutines.launch

@Composable
fun BotonFavorito(
    id: String,
    tipo: String, // "RESTAURANTE" o "PRODUCTO"
    idRestauranteAsociado: String = "",
    size: Dp = 32.dp,
    iconSize: Dp = 18.dp,
    containerColor: Color = Color.White.copy(alpha = 0.8f)
) {
    val scope = rememberCoroutineScope()
    val favoritosSet by FavoritosRepository.favoritosSet.collectAsState()
    val esFav = favoritosSet.contains(id)
    
    // Animación de pulso
    val scale = remember { Animatable(1f) }

    Box(
        modifier = Modifier
            .size(size)
            .clip(CircleShape)
            .background(containerColor)
            .scale(scale.value)
            .clickable {
                scope.launch {
                    // Animación de pulso al tocar
                    scale.animateTo(
                        targetValue = 1.3f,
                        animationSpec = tween(100)
                    )
                    scale.animateTo(
                        targetValue = 1f,
                        animationSpec = spring(
                            dampingRatio = Spring.DampingRatioMediumBouncy,
                            stiffness = Spring.StiffnessLow
                        )
                    )
                    FavoritosRepository.alternarFavorito(id, tipo, idRestauranteAsociado)
                }
            },
        contentAlignment = Alignment.Center
    ) {
        Icon(
            imageVector = if (esFav) Icons.Default.Favorite else Icons.Default.FavoriteBorder,
            contentDescription = "Favorito",
            tint = if (esFav) Color.Red else Color.Gray,
            modifier = Modifier.size(iconSize)
        )
    }
}
